export default class ComponentCalendario {
    constructor() {

        this.calendar = document.querySelector('.em-calendar')
        this.eventDays = this.calendar.querySelectorAll(".em-cal-day")

        this.ready();
    }

    ready() {

        this.eventDays.forEach((e) => {
            e.addEventListener('click', (event) => {
                event.preventDefault()
            })
        })

    }
}